<template>
    <div>
        <!-- PRevious update was saved in Transferordermodalold with 2971 line and this new page has parent product addition  -->
        <!-- Loading overlay for full page loading -->
        <loading
            :active="loading && items.length === 0"
            :can-cancel="false"
            :is-full-page="true"
            :width="60"
            :height="60"
            color="#007bff"
            background-color="#fff"
            loader="spinner"
        ></loading>

        <!-- Global loading indicator for item locations -->
        <div v-if="anyItemLoading" class="global-loading-indicator" style="position: fixed; top: 190px; right: 880px; z-index: 9999;">
            <div class="spinner-container" style="background: white; padding: 5px 10px; border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
                <b-spinner small variant="primary" style="margin-right: 5px;"></b-spinner>
                <small style="color: #666;">Loading locations...</small>
            </div>
        </div>

        <!-- Save operation loading -->
        <div v-if="saveLoading" class="save-loading-overlay">
            <div class="save-loading-content">
                <b-spinner variant="primary"></b-spinner>
                <span>Saving transfer order...</span>
            </div>
        </div>

        <b-card style="width: 100%; margin: 0px; padding: 0px;" no-body>
            <b-alert show>TRANSFER ORDER # {{id}} (Status: {{statusText}})</b-alert>
            
            <!-- Show content when data is loaded -->
            <span v-if="dataLoaded">
                <!-- Auto-expand toggle -->
                <b-card-text class="mb-2">
                    <b-form-checkbox 
                        v-model="autoExpandParents" 
                        switch
                        size="sm"
                        :disabled="shouldDisableFields || saveLoading">
                        <small>Auto-expand parent products</small>
                    </b-form-checkbox>
                </b-card-text>
                
                <!-- Add loading indicator for products dropdown -->
                <div v-if="loadingProducts" style="text-align: center; padding: 10px; margin-bottom: 10px;">
                    <b-spinner small variant="primary"></b-spinner>
                    <span style="margin-left: 5px; font-size: 12px;">Loading products...</span>
                </div>
                
                <b-card-text class="d-flex flex-column flex-lg-row">
                    <b-card-text :disabled="shouldDisableFields" style="display: inline-block; vertical-align: top;">
                        <span :disabled="shouldDisableFields" v-if="products.length > 0">
                            <vue-simple-suggest
                                :disabled="shouldDisableFields || loadingProducts"
                                v-model="product_search_keyword"
                                display-attribute="product_name"
                                value-attribute="product_sku"
                                :max-suggestions="200"
                                :list="products"
                                :filter-by-query="true"
                                @select="add_item"
                                :filter="filter_products"
                                ref="product_sku"
                                style="margin-bottom: 10px; font-size: 16px; font-family: monospace; border: 1px solid black;"
                                class="input-field"
                                :class="{ 'loading-disabled': loadingProducts }"
                            >
                                <template v-slot:suggestion-item="{ suggestion }">
                                    <div class="d-flex align-items-center justify-content-between w-100">
                                        <div>
                                            <span>{{ suggestion.product_name }} [{{suggestion.product_sku}}]</span>
                                            <span v-if="suggestion.is_parent_product" 
                                                class="badge badge-info ml-2" 
                                                style="font-size: 9px;">
                                                Parent ({{ getChildrenCount(suggestion) }} children)
                                            </span>
                                        </div>
                                        <small v-if="suggestion.is_parent_product" class="text-muted">
                                            {{ suggestion.available || 0 }} available
                                        </small>
                                    </div>
                                </template>
                                <template v-slot:misc-item-above>
                                    <div v-if="loadingProducts" class="text-center py-2">
                                        <b-spinner small variant="primary"></b-spinner>
                                        <span class="ml-2">Loading products...</span>
                                    </div>
                                </template>
                            </vue-simple-suggest>
                        </span>
                        <span v-else-if="loadingProducts">
                            <b-alert variant="info" show>
                                <b-spinner small variant="primary"></b-spinner>
                                Loading products...
                            </b-alert>
                        </span>
                        <span v-else>
                            <b-alert variant="warning" show>NO PRODUCTS AVAILABLE</b-alert>
                        </span>
                    </b-card-text>

                    <b-card-text style="display: inline-block; vertical-align: top;" class="ml-0 ml-lg-2">
                        <div v-if="items.length > 0">
                            <b-button variant="success" @click="save_transfer_order_items" :disabled="saveLoading">
                                <b-spinner small v-if="saveLoading"></b-spinner>
                                <span v-else>SAVE</span>
                            </b-button>
                        </div>
                        <div v-else>
                            <b-button variant="warning" @click="close_it" :disabled="saveLoading">CANCEL</b-button>
                        </div>
                    </b-card-text>

                    <div v-if="items.length > 0" style="display: inline-block; margin-right: 10px;margin-left: 10px;">
                        <b-button variant="primary" @click="exportTransferOrderToExcel" 
                                :disabled="items.length === 0 || saveLoading">
                            EXPORT EXCEL
                        </b-button>
                    </div>
                </b-card-text>

                <b-card-text>
                    <!-- Show loading for items when loading -->
                    <div v-if="loadingItems" style="text-align: center; padding: 20px;">
                        <b-spinner small variant="primary"></b-spinner>
                        <span> Loading items...</span>
                    </div>
                    
                    <b-card-text v-if="!loadingItems && items.length > 0" class="diver">
                        <div class="table-wrapper">
                            <table class="text-monospace sticky-table">
                                <thead>
                                    <tr>
                                        <td style="min-width: 100px; width: 100px;">&nbsp;</td>
                                        <td style="min-width: 120px; width: 120px;">&nbsp;</td>
                                        <td style="min-width: 70px; width: 70px;" v-if="['admin', 'officemanager', 'accountmanager'].includes(packet.userDetails.userrole)">&nbsp;</td>
                                        <td style="min-width: 60px; width: 60px;">&nbsp;</td>
                                        <td style="min-width: 60px; width: 60px;">&nbsp;</td>
                                        <td style="min-width: 60px; width: 60px;">&nbsp;</td>
                                        <td style="min-width: 60px; width: 60px;">&nbsp;</td>
                                        <td style="min-width: 120px; width: 120px;">
                                            <b-form-select
                                                v-model="bulkStatus"
                                                :options="bulkStatusOptions"
                                                size="sm"
                                                v-if="['admin', 'officemanager', 'accountmanager'].includes(packet.userDetails.userrole)"
                                                :disabled="!isAdmin || shouldDisableFields || saveLoading"
                                                @change="applyBulkStatus"
                                                style="font-size: 11px;"
                                            >
                                                <template v-slot:first>
                                                    <option value="">SELECT STATUS</option>
                                                </template>
                                            </b-form-select>
                                        </td>
                                        <td style="min-width: 150px; width: 150px;">
                                            <date-picker
                                                v-model="delivery_date"
                                                v-if="['admin', 'officemanager', 'accountmanager'].includes(packet.userDetails.userrole)"
                                                :disabled=" !isAdmin || shouldDisableFields || saveLoading"
                                                format="MM-DD-YYYY"
                                                valueType="format"
                                                style="padding: 1px; font-size: 9px; text-align: center; border: 1px solid gray; width: 150px; font-size: 11px; font-family: roboto; margin: auto;"
                                                v-on:change="apply_date"
                                            ></date-picker>
                                        </td>
                                        <td style="min-width: 100px; width: 100px;">&nbsp;</td>
                                        <td style="min-width: 50px; width: 50px;">&nbsp;</td> 
                                        <td style="min-width: 150px; width: 150px;" v-if="['admin', 'officemanager', 'warehouseuser', 'warehousemanager'].includes(packet.userDetails.userrole)">&nbsp;</td>
                                        <td style="min-width: 150px; width: 150px;" v-if="['admin', 'officemanager', 'warehouseuser', 'warehousemanager'].includes(packet.userDetails.userrole)">&nbsp;</td>
                                        <td class="srr" style="min-width: 200px; width: 200px;" v-if="['admin', 'officemanager', 'warehouseuser', 'warehousemanager'].includes(packet.userDetails.userrole)">
                                            <div class="d-flex align-items-center justify-content-between">
                                                <b-button 
                                                    size="sm" 
                                                    variant="outline-primary" 
                                                    @click="loadAllAvailability"
                                                    :disabled="isLoadingAllAvailability || saveLoading"
                                                    v-b-tooltip.hover title="Load availability for all items"
                                                    style="font-size: 9px; padding: 2px 5px;"
                                                >
                                                    <b-spinner small v-if="isLoadingAllAvailability"></b-spinner>
                                                    <template v-else>
                                                        <b-icon icon="arrow-repeat" small></b-icon> Load All
                                                    </template>
                                                </b-button>
                                                <span>AVAILABILITY</span>
                                            </div>
                                        </td>
                                        <td style="min-width: 100px; width: 100px;">&nbsp;</td>
                                        <td style="min-width: 150px; width: 150px;">
                                            <date-picker
                                                v-model="schedule_date"
                                                v-if="['admin', 'officemanager', 'accountmanager'].includes(packet.userDetails.userrole)"
                                                :disabled=" !isAdmin || shouldDisableFields || saveLoading"
                                                format="MM-DD-YYYY"
                                                valueType="format"
                                                style="padding: 1px; font-size: 9px; text-align: center; border: 1px solid gray; width: 150px; font-size: 11px; font-family: roboto; margin: auto;"
                                                v-on:change="apply_date2"
                                            ></date-picker>
                                        </td>
                                        <td style="min-width: 150px; width: 150px;">
                                            <b-card-text style="display: inline-block; vertical-align: top; margin-left: 20px;">
                                                <b-button
                                                    v-if="main_schedule_date && !allItemsHaveScheduleDate"
                                                    @click="applyMainScheduleDate"
                                                    variant="outline-primary"
                                                    size="sm"
                                                    :disabled="shouldDisableFields || saveLoading"
                                                    v-b-tooltip.hover title="Apply main Schedule date to all items"
                                                >
                                                    <b-icon icon="calendar-check"></b-icon>
                                                    Apply
                                                </b-button>
                                            </b-card-text>
                                        </td>
                                        <td style="min-width: 100px; width: 100px;" v-if="['admin', 'officemanager', 'accountmanager'].includes(packet.userDetails.userrole)">&nbsp;</td>
                                        <td style="min-width: 100px; width: 100px;">&nbsp;</td>
                                        <td style="min-width: 100px; width: 100px;">&nbsp;</td>
                                    </tr>
                                </thead>

                                <thead>
                                    <tr>
                                        <th class="srr sticky-col-1" style="min-width: 100px; width: 100px;">
                                            PRODUCT SKU
                                        </th>
                                        <th class="srr sticky-col-2" style="min-width: 120px; width: 120px;">
                                            DESCRIPTION
                                        </th>
                                        <th class="srr" style="min-width: 70px; width: 70px;" v-if="['admin', 'officemanager', 'accountmanager'].includes(packet.userDetails.userrole)">
                                            WHLSL
                                        </th>
                                        <th class="srr" style="min-width: 60px; width: 60px;">
                                            QTY
                                        </th>
                                        <th class="srr" style="min-width: 60px; width: 60px;">
                                            SCH QTY
                                        </th>
                                        <th class="srr" style="min-width: 60px; width: 60px;">
                                            SHIPPED QTY
                                        </th>
                                        <th class="srr" style="min-width: 60px; width: 60px;">
                                            RCV QTY
                                        </th>
                                        <th class="srr" style="min-width: 120px; width: 120px;">
                                            ITEM STATUS
                                        </th>
                                        <th class="srr" style="min-width: 150px; width: 150px;" v-if="['admin', 'officemanager', 'warehouseuser', 'warehousemanager'].includes(packet.userDetails.userrole)">
                                            SCHEDULE DATE
                                        </th>
                                        <th class="srr" style="min-width: 100px; width: 100px;">
                                            DEL STATUS
                                        </th>
                                        <th class="srr" style="min-width: 60px; width: 60px;">
                                            Cubes
                                        </th>
                                        <th class="srr" style="min-width: 150px; width: 150px;" v-if="['admin', 'officemanager', 'warehouseuser', 'warehousemanager'].includes(packet.userDetails.userrole)">
                                            ITEM LOC
                                        </th>
                                        <th class="srr" style="min-width: 150px; width: 150px;" v-if="['admin', 'officemanager', 'warehouseuser', 'warehousemanager'].includes(packet.userDetails.userrole)">
                                            RECEIVE LOC
                                        </th>
                                        <th class="srr" style="min-width: 200px; width: 200px;" v-if="['admin', 'officemanager', 'warehouseuser', 'warehousemanager'].includes(packet.userDetails.userrole)">
                                            AVAILABILITY
                                        </th>
                                        <th class="srr" style="min-width: 70px; width: 70px;" v-if="['admin', 'officemanager', 'accountmanager'].includes(packet.userDetails.userrole)">
                                            TOTAL
                                        </th>
                                        <th class="srr" style="min-width: 150px; width: 150px;" v-if="['admin', 'officemanager', 'warehouseuser', 'warehousemanager'].includes(packet.userDetails.userrole)">
                                            REQUEST ETA
                                        </th>
                                        <th class="srr" style="min-width: 150px; width: 150px;">
                                            RECEIVED DATE
                                        </th>
                                        <th class="srr" style="min-width: 100px; width: 100px;" v-if="['admin', 'officemanager', 'warehouseuser', 'warehousemanager'].includes(packet.userDetails.userrole)">
                                            COMMENTS
                                        </th>
                                        <th class="srr" style="min-width: 100px; width: 100px;" v-if="['admin', 'officemanager', 'warehouseuser', 'warehousemanager'].includes(packet.userDetails.userrole)">
                                            PICTURE
                                        </th>
                                        <th class="srr" style="min-width: 80px; width: 80px;" v-if="read_only != true && ['admin', 'officemanager', 'warehouseuser', 'warehousemanager'].includes(packet.userDetails.userrole)">
                                            ACTION
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <!-- Group items by parent -->
                                    <template v-for="(group, parentSku) in groupedItems">
                                        <!-- Parent header row (only if not standalone and has children) -->
                                        <tr v-if="parentSku !== 'standalone' && group.some(item => item.is_child_product)" 
                                            :key="'parent-header-' + parentSku"
                                            style="background-color: #f0f8ff; font-weight: bold; border-top: 2px solid #007bff;">
                                            <td colspan="22" style="padding: 8px 5px;">
                                                <div class="d-flex align-items-center">
                                                    <b-icon icon="box-seam" class="mr-2" variant="primary"></b-icon>
                                                    <span>Parent Product: {{ getParentName(parentSku) }} [{{parentSku}}]</span>
                                                    <small class="ml-3 text-muted">
                                                        {{ group.filter(item => item.is_child_product).length }} child item(s)
                                                    </small>
                                                    <b-button 
                                                        v-if="!shouldDisableFields && isAdmin && !saveLoading"
                                                        size="sm" 
                                                        variant="outline-danger" 
                                                        class="ml-auto"
                                                        @click="removeParentGroup(parentSku)"
                                                        v-b-tooltip.hover title="Remove all child items for this parent">
                                                        <b-icon icon="trash"></b-icon> Remove All
                                                    </b-button>
                                                </div>
                                            </td>
                                        </tr>
                                        
                                        <!-- Child items or standalone items -->
                                        <tr v-for="item in group" 
                                            :key="item.product_sku + '-' + (item.is_child_product ? 'child' : 'standalone')"
                                            :style="item.is_child_product ? {backgroundColor: '#f8f9fa'} : {}">
                                            <td class="srrv sticky-col-1">
                                                <div class="d-flex align-items-center">
                                                    <span>{{item.product_sku}}</span>
                                                    <span v-if="item.is_child_product" 
                                                        class="badge badge-secondary ml-1" 
                                                        style="font-size: 8px;">
                                                        Child
                                                    </span>
                                                </div>
                                            </td>

                                            <td class="srrv sticky-col-2">
                                                {{item.product_name}}
                                                <small v-if="item.is_child_product && item.required_quantity > 1" 
                                                    class="text-muted d-block">
                                                    (Required: {{ item.required_quantity }} per parent)
                                                </small>
                                            </td>

                                            <td class="srrv" v-if="['admin', 'officemanager', 'accountmanager'].includes(packet.userDetails.userrole)">
                                                {{(item.wholesale_price || 0.0).toFixed(2)}}
                                            </td>

                                            <td class="srrv">
                                                <b-form-input
                                                    v-model="item.quantity"
                                                    size="sm"
                                                    type="number"
                                                    style="font-size: 11px;"
                                                    :disabled=" isItemDisabled(item) || saveLoading"
                                                    @input="onQuantityInput(item)"
                                                ></b-form-input>
                                            </td>
                                            <td class="srrv">
                                                <b-form-input
                                                    v-model="item.quantity_scheduled"
                                                    size="sm"
                                                    type="number"
                                                    style="font-size: 11px;"
                                                    :min="getMinQuantity(item)"
                                                    :max="item.quantity"
                                                    :disabled="shouldDisableFields || !isAdmin || isItemDisabled(item) || saveLoading"
                                                    @keydown="preventInvalidEntry($event, item)"
                                                    @input="onScheduledQuantityInput(item)"
                                                    @blur="validateScheduledQuantity(item)"
                                                ></b-form-input>
                                            </td>

                                            <td class="srrv">
                                                <b-form-input
                                                    v-model="item.quantity_shipped"
                                                    size="sm"
                                                    type="number"
                                                    style="font-size: 11px;"
                                                    :min="0"
                                                    :max="item.quantity"
                                                    :disabled="shouldDisableFields || !isAdmin || isItemDisabled(item) || (item.status !== 2 && item.status !== 6) || saveLoading"
                                                    @keydown="preventInvalidEntry($event, item)"
                                                    @blur="validateShippedQuantity(item)"
                                                ></b-form-input>
                                            </td>

                                            <td class="srrv">
                                                <b-form-input
                                                    v-model="item.quantity_received"
                                                    size="sm"
                                                    type="number"
                                                    style="font-size: 11px;"
                                                    :min="getMinQuantity(item)"
                                                    :max="item.quantity_scheduled || item.quantity"
                                                    :disabled="isItemDisabled(item) || (item.status !== 2 && item.status !== 3 && item.status !== 4) || saveLoading"
                                                    @keydown="preventInvalidEntry($event, item)"
                                                    @change="validateQuantity(item)"
                                                ></b-form-input>
                                            </td>

                                            <td class="srrv">
                                                <b-form-select
                                                    :options="getStatusOptions(item)"
                                                    v-model="item.status"
                                                    size="sm"
                                                    style="font-size: 11px;"
                                                    :disabled="shouldDisableFields  || !isAdmin || isItemDisabled(item) || saveLoading"
                                                    @change="handleStatusChange(item)"
                                                    :state="getStatusState(item)"
                                                    required
                                                ></b-form-select>
                                            </td>

                                            <td class="srrv" v-if="['admin', 'officemanager', 'warehouseuser', 'warehousemanager'].includes(packet.userDetails.userrole)">
                                                <div style="display: flex; align-items: center; position: relative;">
                                                    <date-picker
                                                        v-model="item.delivery_date"
                                                        :disabled="shouldDisableFields || !isAdmin || isItemDisabled(item) || saveLoading"
                                                        format="MM-DD-YYYY"
                                                        valueType="format"
                                                        style="padding: 1px; text-align: center; border: 1px solid gray; width: 140px; font-size: 11px; font-family: roboto; position: relative;"
                                                        @change="onDeliveryDateChange(item, $event)"
                                                    ></date-picker>
                                                    <b-badge
                                                        v-if="item.has_external_delivery_date"
                                                        variant="warning"
                                                        style="position: absolute; top: -8px; right: -8px; z-index: 10; font-size: 9px; padding: 2px 4px;"
                                                        v-b-tooltip.hover title="Date applied from main order"
                                                    >
                                                        ETA
                                                    </b-badge>
                                                </div>
                                            </td>

                                            <td class="srrv">
                                                <b-form-select
                                                    :options="delivery_statuses"
                                                    v-model="item.delivery_status"
                                                    size="sm"
                                                    style="font-size: 11px;"
                                                    :disabled=" shouldDisableFields || !isAdmin || isItemDisabled(item) || saveLoading"
                                                    required
                                                ></b-form-select>
                                            </td>

                                            <td class="srrv">
                                                {{
                                                    ((item.cubes || 0.0) * (item.quantity || 0.0)).toFixed(2)
                                                }}
                                            </td>

                                            <td class="srrv" v-if="['admin', 'officemanager', 'warehouseuser', 'warehousemanager'].includes(packet.userDetails.userrole)">
                                                <template v-if="item.quantity > 0">
                                                    <div v-if="reservedLocationRequests[item.product_sku]" style="text-align: center; padding: 5px;" class="reserved-location-loading">
                                                        <b-spinner small variant="primary"></b-spinner>
                                                        <span style="font-size: 10px; margin-left: 5px;">Loading locations...</span>
                                                    </div>
                                                    
                                                    <template v-if="item.reserved_locsub && !reservedLocationRequests[item.product_sku]">
                                                        <div v-if="item.reservedLocationOptions && item.reservedLocationOptions.length > 0">
                                                            <b-form-select
                                                                v-model="item.reserved_locsub"
                                                                :options="item.reservedLocationOptions"
                                                                size="sm"
                                                                style="font-size: 11px;"
                                                                :disabled="shouldDisableFields || !isAdmin || isItemDisabled(item) || saveLoading"
                                                                @change="onReservedLocationChange(item)"
                                                            >
                                                            </b-form-select>
                                                        </div>
                                                    </template>
                                                    
                                                    <template v-else-if="!reservedLocationRequests[item.product_sku]">
                                                        <b-form-select
                                                            v-if="item.reservedLocationOptions && item.reservedLocationOptions.length > 0"
                                                            v-model="item.reserved_locsub"
                                                            :options="item.reservedLocationOptions"
                                                            size="sm"
                                                            style="font-size: 11px;"
                                                            :disabled="shouldDisableFields || !isAdmin || isItemDisabled(item) || saveLoading"
                                                            @change="onReservedLocationChange(item)"
                                                        >
                                                        </b-form-select>
                                                        
                                                        <span v-else style="font-size: 10px; color: #666;">
                                                            No locations available
                                                        </span>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    Enter Qty to see locations
                                                </template>
                                            </td>

                                            <!-- RECEIVE LOC Column -->
                                            <td class="srrv" v-if="['admin', 'officemanager', 'warehouseuser', 'warehousemanager'].includes(packet.userDetails.userrole)">
                                                <b-form-select 
                                                    :options="filteredLocations" 
                                                    v-model="item.locsub" 
                                                    size="sm" 
                                                    style="font-size: 11px;"
                                                    :disabled="shouldDisableFields || isItemDisabled(item) || saveLoading"
                                                ></b-form-select>
                                            </td>

                                            <td class="srrv" v-if="['admin', 'officemanager', 'warehouseuser', 'warehousemanager'].includes(packet.userDetails.userrole)">
                                                <table class="table-sm availability-table">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 50px;"> STK</th>
                                                            <th style="width: 50px;">RSVD</th>
                                                            <th style="width: 50px;">AVBL</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <template v-if="!item.hasFetchedAvailability && !availabilityLoading[item.product_sku]">
                                                                    <span @click="fetchItemAvailability(item)" 
                                                                        style="cursor: pointer; color: blue; text-decoration: underline; font-size: 10px;">
                                                                        Load
                                                                    </span>
                                                                </template>
                                                                <template v-else-if="availabilityLoading[item.product_sku]">
                                                                    <b-spinner small></b-spinner>
                                                                </template>
                                                                <template v-else>
                                                                    {{ item.in_stock }}
                                                                </template>
                                                            </td>
                                                            
                                                            <td>
                                                                <template v-if="!item.hasFetchedAvailability && !availabilityLoading[item.product_sku]">
                                                                    --
                                                                </template>
                                                                <template v-else-if="availabilityLoading[item.product_sku]">
                                                                    <b-spinner small></b-spinner>
                                                                </template>
                                                                <template v-else>
                                                                    {{ item.reserved }}
                                                                </template>
                                                            </td>
                                                            
                                                            <td>
                                                                <template v-if="!item.hasFetchedAvailability && !availabilityLoading[item.product_sku]">
                                                                    --
                                                                </template>
                                                                <template v-else-if="availabilityLoading[item.product_sku]">
                                                                    <b-spinner small></b-spinner>
                                                                </template>
                                                                <template v-else>
                                                                    {{ item.available }}
                                                                </template>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>

                                            <td class="srrv" v-if="['admin', 'officemanager', 'accountmanager'].includes(packet.userDetails.userrole)">
                                                {{
                                                    ((item.wholesale_price || 0.0) * (item.quantity || 0.0)).toFixed(2)
                                                }}
                                            </td>

                                            <td class="srrv" v-if="['admin', 'officemanager', 'warehouseuser', 'warehousemanager'].includes(packet.userDetails.userrole)">
                                                <div style="display: flex; align-items: center; position: relative;">
                                                    <date-picker
                                                        v-model="item.schedule_date"
                                                        :disabled="shouldDisableFields ||  !isAdmin || isItemDisabled(item) || saveLoading"
                                                        format="MM-DD-YYYY"
                                                        valueType="format"
                                                        style="padding: 1px; font-size: 9px; text-align: center; border: 1px solid gray; width: 140px; font-size: 11px; font-family: roboto; position: relative;"
                                                        @change="onScheduleDateChange(item, $event)"
                                                    ></date-picker>
                                                    <b-badge
                                                        v-if="item.has_external_schedule_date"
                                                        variant="warning"
                                                        style="position: absolute; top: -8px; right: -8px; z-index: 10; font-size: 9px; padding: 2px 4px;"
                                                        v-b-tooltip.hover title="Date applied from main order"
                                                    >
                                                        ETA     
                                                    </b-badge>
                                                </div>
                                            </td>
                                            <td class="srrv">
                                                <div v-b-tooltip.hover title="">
                                                    <date-picker
                                                        v-model="item.received_date"
                                                        :disabled="shouldDisableFields || isItemDisabled(item) || item.status !== 3 || saveLoading"
                                                        format="MM-DD-YYYY"
                                                        valueType="format"
                                                        :disabled-date="disableFutureDates"
                                                        style="padding: 1px; font-size: 9px; text-align: center; border: 1px solid gray; width: 140px; font-size: 11px; font-family: roboto;"
                                                        @change="onReceivedDateChange(item, $event)"
                                                    ></date-picker>
                                                </div>
                                            </td>

                                            <td class="srrv" v-if="['admin', 'officemanager', 'warehouseuser', 'warehousemanager'].includes(packet.userDetails.userrole)">
                                                <b-form-input
                                                    v-model="item.comments"
                                                    size="sm"
                                                    type="text"
                                                    style="font-size: 11px;"
                                                    :disabled="isItemDisabled(item) || saveLoading"
                                                ></b-form-input>
                                            </td>

                                            <td class="srrv" v-if="['admin', 'officemanager', 'warehouseuser', 'warehousemanager'].includes(packet.userDetails.userrole)">
                                                <div style="display: flex; flex-direction: column; align-items: center;">
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        @change="handleImageUpload($event, item, idx)"
                                                        style="display: none;"
                                                        :ref="'fileInput-' + idx"
                                                        :disabled="isItemDisabled(item) || saveLoading"
                                                    >
                                                    <b-button
                                                        v-if="!item.images || item.images.length === 0"
                                                        size="sm"
                                                        variant="outline-primary"
                                                        @click="$refs['fileInput-' + idx][0].click()"
                                                        :disabled="isItemDisabled(item) || saveLoading"
                                                    >
                                                        Upload
                                                    </b-button>
                                                    <div v-else style="position: relative;">
                                                        <img
                                                            :src="getImageSrc(item.images[0])"
                                                            style="max-width: 80px; max-height: 60px; cursor: pointer;"
                                                            @click="showImagePreview(item)"
                                                            class="img-thumbnail"
                                                        >
                                                        <b-button
                                                            variant="danger"
                                                            size="xs"
                                                            @click="removeImage(item, idx)"
                                                            style="position: absolute; top: -10px; right: -10px; padding: 2px 5px;"
                                                            :disabled="isItemDisabled(item) || saveLoading"
                                                        >
                                                            ×
                                                        </b-button>
                                                    </div>
                                                </div>
                                            </td>

                                            <td class="srrv" v-if="read_only != true && ['admin', 'officemanager', 'warehouseuser', 'warehousemanager'].includes(packet.userDetails.userrole)">
                                                <b-button size="sm" style="font-size: 14px;" variant="danger" @click="remove_item(item)" v-b-tooltip.hover title="DELETE ITEM" :disabled="shouldDisableFields || isItemDisabled(item) || saveLoading">
                                                    <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
                                                </b-button>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </b-card-text>
                    <b-card-text v-else-if="!loadingItems">
                        <b-alert show variant="primary">NO ITEMS ADDED TO THIS ORDER YET.</b-alert>
                    </b-card-text>
                </b-card-text>
            </span>
            
            <div v-else-if="loading && dataLoaded">
                <div style="text-align: center; padding: 50px;">
                    <b-spinner variant="primary" label="Loading..."></b-spinner>
                    <p>Loading products...</p>
                </div>
            </div>
        </b-card>

        <div v-if="paymentsLoaded">
            <b-card v-if="id && !loading" style="margin: 0px; margin-top: 10px;  padding: 0px;" no-body>
                <b-alert show>PAYMENTS HISTORY</b-alert>

                <b-alert :variant="paymentAlertVariant" show style="margin-top: 0px;">
                    <b-card-text style="display: inline-block; vertical-align: top;">
                        <b-input
                            size="sm"
                            style="width: 150px;"
                            type="number"
                            placeholder="amount"
                            v-model="new_payment.amount"
                            :disabled="shouldDisableFields || paymentsLoading"
                            :state="isPaymentAmountValid"
                            @input="validatePaymentAmount"
                        ></b-input>
                    </b-card-text>
                    <b-card-text style="display: inline-block; vertical-align: top;">
                        <b-form-select
                            size="sm"
                            style="width: 200px;"
                            :options="payment_methods"
                            v-model="new_payment.payment_method"
                            :disabled="shouldDisableFields || paymentsLoading"
                        ></b-form-select>
                    </b-card-text>

                    <b-card-text style="display: inline-block; vertical-align: top;"
                                v-if="new_payment.amount && new_payment.payment_method">
                        <b-button
                            size="sm"
                            variant="outline-dark"
                            :disabled="shouldDisableFields || !isPaymentAmountValid || paymentsLoading"
                            @click="add_transfer_order_payment"
                        >
                            <b-spinner small v-if="paymentsLoading"></b-spinner>
                            <span v-else>ADD PAYMENT</span>
                        </b-button>
                    </b-card-text>

                    <b-card-text v-if="paymentError" class="text-danger mt-1">
                        {{ paymentError }}
                    </b-card-text>
                </b-alert>

                <div v-if="payments.length > 0" class="diver">
                    <b-card-text>
                        <table style="width: 100%;">
                            <thead>
                                <tr>
                                    <td class="srr" style="width: 100px;">PAID AT</td>
                                    <td class="srr" style="width: 100px;">AMOUNT</td>
                                    <td class="srr" style="width: 100px;">PAYMENT TYPE</td>
                                    <td class="srr" style="width: 100px;">ACTION</td>
                                </tr>
                            </thead>

                            <thead>
                                <tr>
                                    <td class="srrv"></td>
                                    <td class="srrv" style="background: lightyellow; font-weight: bold;">
                                        <p style="border: 1px solid black; margin-left: auto; margin-right: auto; display: block; width: 150px; margin-top: 3px; margin-bottom: 3px;">
                                            TOTAL DUE = ${{(get_total_due() || 0.0).toFixed(2)}}
                                        </p>
                                        <p style="border: 1px solid black; margin-left: auto; margin-right: auto; display: block; width: 150px; margin-top: 3px; margin-bottom: 3px;">
                                            TOTAL PAID = ${{(get_total_paid() || 0.0).toFixed(2)}}
                                        </p>
                                        <p style="border: 1px solid black; margin-left: auto; margin-right: auto; display: block; width: 180px; margin-top: 3px; margin-bottom: 3px;">
                                            REMAINING BALANCE = ${{((get_total_due() || 0.0) - (get_total_paid() || 0.0)).toFixed(2)}}
                                        </p>
                                    </td>
                                    <td class="srrv"></td>
                                    <td class="srrv"></td>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="pm,pmidx in payments" v-bind:key="pmidx">
                                    <td class="srrv">{{pm.ts}}</td>
                                    <td class="srrv">{{(pm.amount || 0.0).toFixed(2)}}</td>
                                    <td class="srrv">{{payment_methods_dict[pm.payment_method]}}</td>
                                    <td class="srrv">
                                        <b-button size="sm" v-if="packet.userDetails.userrole == 'admin'" v-b-tooltip.hover title="DELETE PAYMENT ENTRY" @click="delete_transfer_order_payment(pm)" :disabled="paymentsLoading">
                                            <b-spinner small v-if="paymentsLoading"></b-spinner>
                                            <b-icon v-else icon="trash-fill" aria-hidden="true"></b-icon>
                                        </b-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </b-card-text>
                </div>

                <div v-else>
                    <div v-if="payments_being_loaded">
                        <div style="text-align: center; padding: 20px;">
                            <b-spinner variant="primary"></b-spinner>
                            <p>Loading payments...</p>
                        </div>
                    </div>
                    <div v-else>
                        <b-card-text class="srrv">NO PAYMENTS FOR THIS ORDER YET</b-card-text>
                    </div>
                </div>
            </b-card>
        </div>
        <div v-else-if="!payments_being_loaded">
            <b-card style="margin: 20px 0; text-align: center; padding: 20px;">
                <p class="text-muted">Payments data not loaded</p>
                <b-button variant="info" @click="loadPayments" :disabled="paymentsLoading">
                    <b-spinner small v-if="paymentsLoading"></b-spinner>
                    <b-icon v-else icon="cash-stack" class="mr-2"></b-icon>
                    Load Payments
                </b-button>
            </b-card>
        </div>

        <div v-if="historyLoaded">
            <b-card v-if="id && !loading" style="margin: 0px; margin-top: 10px; padding: 0px;" no-body>
                <b-alert show>TRANSFER ORDER HISTORY</b-alert>

                <div v-if="transferOrderHistory.length > 0" class="diver">
                    <b-card-text>
                        <table style="width: 100%;" class="text-monospace">
                            <thead>
                                <tr>
                                    <td class="srr" style="width: 100px;">DATE</td>
                                    <td class="srr" style="width: 100px;">SKU</td>
                                    <td class="srr" style="width: 200px;">DESCRIPTION</td>
                                    <td class="srr" style="width: 60px;">QTY ORD</td>
                                    <td class="srr" style="width: 60px;">QTY RCVD</td>
                                    <td class="srr" style="width: 100px;">STATUS</td>
                                    <td class="srr" style="width: 100px;">DROP LOCATION</td>
                                    <td class="srr" style="width: 100px;">CHANGED BY</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="historyItem, idx in transferOrderHistory" :key="idx">
                                    <td class="srrv">{{ historyItem.change_date }}</td>
                                    <td class="srrv">{{ historyItem.product_sku }}</td>
                                    <td class="srrv">{{ historyItem.item_description }}</td>
                                    <td class="srrv">{{ historyItem.quantity_ordered }}</td>
                                    <td class="srrv">{{ historyItem.quantity_received }}</td>
                                    <td class="srrv">{{ historyItem.status_text }}</td>
                                    <td class="srrv">{{ historyItem.drop_location_name || historyItem.drop_location }}</td>
                                    <td class="srrv">{{ historyItem.changed_by }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </b-card-text>
                </div>

                <div v-else>
                    <div v-if="historyLoading">
                        <div style="text-align: center; padding: 20px;">
                            <b-spinner variant="primary"></b-spinner>
                            <p>Loading history...</p>
                        </div>
                    </div>
                    <div v-else>
                        <b-card-text class="srrv">NO HISTORY FOR THIS TRANSFER ORDER YET</b-card-text>
                    </div>
                </div>
            </b-card>
        </div>
        <div v-else-if="!historyLoading">
            <b-card style="margin: 20px 0; text-align: center; padding: 20px;">
                <p class="text-muted">History data not loaded</p>
                <b-button variant="success" @click="loadHistory" :disabled="historyLoading">
                    <b-spinner small v-if="historyLoading"></b-spinner>
                    <b-icon v-else icon="clock-history" class="mr-2"></b-icon>
                    Load Order History
                </b-button>
            </b-card>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import VueSimpleSuggest from 'vue-simple-suggest'
    import mappings from '@/utilities/mappings'
    import 'vue-simple-suggest/dist/styles.css'

    export default {
        name: "TransferOrderModal",
        props: ["viewdata"],
        components: {flatPickr, Loading, DatePicker, VueSimpleSuggest},
        data: function(){
            return {
                packet: {},
                id: null,
                read_only: false,
                order_status: null,
                paymentError: null,
                paymentAlertVariant: 'secondary',
                isLoadingAllAvailability: false,
                loading: false,
                loadingItems: false,
                loadingProducts: false,
                saveLoading: false,
                paymentsLoading: false,
                historyLoading: false,
                external_delivery_date: null,
                external_schedule_date: null,
                external_status: null,
                bulkStatus: '',
                bulkStatusOptions: [
                    { value: 1, text: "ORDERED" },
                    { value: 2, text: "SCHEDULED" },
                    { value: 6, text: "SHIPPED" },
                    { value: 3, text: "RECEIVED" },
                    { value: 4, text: "PARTIAL" },
                    { value: 5, text: "COMPLETED" },
                ],
                status_mapping: {
                    1: "ORDERED",
                    2: "SCHEDULED",
                    6: "SHIPPED",
                    3: "RECEIVED",
                    4: "PARTIAL",
                    5: "COMPLETED",
                },
                delivery_statuses: mappings.states,
                items: [],
                products: [],
                vendor_products: [],
                product_search_keyword: '',
                payments: [],
                payments_being_loaded: null,
                username: null,
                payment_methods: [
                    {value: "CHECK", text: "CHECK"},
                ],
                payment_methods_dict: {
                    "CHECK": "CHECK",
                },
                new_payment: {payment_method: null, amount: null},
                delivery_date: null,
                schedule_date: null,
                received_date: null,
                global_delivery_date: null,
                global_schedule_date: null,
                ordering_location_id: null,
                selling_location_id: null,
                transferOrderHistory: [],
                hasRefreshedAfterSave: false,
                dataLoaded: false,
                paymentsLoaded: false,
                historyLoaded: false,
                reservedLocationRequests: {},
                availabilityLoading: {},
                autoExpandParents: true,
            }
        },

        methods: {
            applyBulkStatus: function(statusValue) {
                if (!statusValue) return;
                
                console.log('Applying bulk status:', statusValue, 'to all items');
                
                let itemsUpdated = 0;
                let itemsWithScheduledQty = 0;
                
                this.items = this.items.map(item => {
                    if (item.original_status === 3) {
                        return item;
                    }
                    
                    item.status = statusValue;
                    itemsUpdated++;
                    
                    if (statusValue === 2) {
                        const orderedQty = parseInt(item.quantity) || 0;
                        if (orderedQty > 0) {
                            item.quantity_scheduled = orderedQty;
                            itemsWithScheduledQty++;
                            
                            if (!item.schedule_date && this.schedule_date) {
                                item.schedule_date = this.schedule_date;
                            } else if (!item.schedule_date) {
                                item.schedule_date = moment().format('MM-DD-YYYY');
                            }
                        }
                    }
                    
                    if (statusValue === 6) {
                        const orderedQty = parseInt(item.quantity) || 0;
                        if (orderedQty > 0 && (!item.quantity_scheduled || item.quantity_scheduled === 0)) {
                            item.quantity_scheduled = orderedQty;
                            itemsWithScheduledQty++;
                        }
                    }
                    
                    if (statusValue === 3) {
                        const orderedQty = parseInt(item.quantity) || 0;
                        if (orderedQty > 0) {
                            if (!item.quantity_scheduled || item.quantity_scheduled === 0) {
                                item.quantity_scheduled = orderedQty;
                                itemsWithScheduledQty++;
                            }
                            item.quantity_received = item.quantity_scheduled || orderedQty;
                            item.received_date = moment().format('MM-DD-YYYY');
                        }
                    }
                    
                    return item;
                });
                
                let message = `Applied ${this.getStatusText(statusValue)} status to ${itemsUpdated} items.`;
                if (itemsWithScheduledQty > 0) {
                    message += ` Scheduled quantity set for ${itemsWithScheduledQty} items.`;
                }
                
                this.$bvToast.toast(
                    message,
                    {title: "Bulk Status Update", autoHideDelay: 3000, variant: "success"}
                );
                
                this.bulkStatus = '';
                this.$forceUpdate();
            },

            getStatusText: function(statusValue) {
                const statusMap = {
                    1: "ORDERED",
                    2: "SCHEDULED",
                    3: "RECEIVED",
                    4: "PARTIAL",
                    5: "COMPLETED",
                    6: "SHIPPED",
                };
                return statusMap[statusValue] || "UNKNOWN";
            },
            
            loadAllAvailability: async function() {
                if (this.items.length === 0) {
                    this.$bvToast.toast(
                        "No items to load availability for",
                        {title: "Info", autoHideDelay: 1500, variant: "info"}
                    );
                    return;
                }

                this.isLoadingAllAvailability = true;
                
                this.$bvToast.toast(
                    `Loading availability for ${this.items.length} items...`,
                    {title: "Loading", autoHideDelay: 2000, variant: "info"}
                );

                let successCount = 0;
                let errorCount = 0;

                for (const item of this.items) {
                    if (item.hasFetchedAvailability || this.availabilityLoading[item.product_sku]) {
                        successCount++;
                        continue;
                    }

                    try {
                        await this.fetchItemAvailability(item);
                        successCount++;
                    } catch (error) {
                        console.error(`Failed to load availability for ${item.product_sku}:`, error);
                        errorCount++;
                    }
                }

                this.isLoadingAllAvailability = false;

                this.$bvToast.toast(
                    `Availability loaded: ${successCount} successful, ${errorCount} failed`,
                    {
                        title: errorCount > 0 ? "Completed with errors" : "Success",
                        variant: errorCount > 0 ? "warning" : "success",
                        autoHideDelay: 3000
                    }
                );
            },
            
            getChildrenCount(suggestion) {
                if (!suggestion.children_data || !Array.isArray(suggestion.children_data)) {
                    return 0;
                }
                return suggestion.children_data.length;
            },
            
            add_item: async function(e) {
                console.log('Adding item:', e);
                
                const existingItem = this.items.find(item => item.product_sku === e.product_sku);
                if (existingItem && !existingItem.is_child_product) {
                    this.$bvToast.toast(
                        "Item already exists in the order",
                        {title: "Warning", autoHideDelay: 1500, variant:"warning"}
                    );
                    return;
                }

                const vm = this;
                
                const getStockLocation = () => {
                    const stockLocations = vm.filteredLocations.filter(loc => {
                        const locText = (loc.text || '').toLowerCase();
                        return !locText.includes('as is') && !locText.includes('damage');
                    });
                    
                    if (stockLocations.length > 0) {
                        return stockLocations[0].value;
                    }
                    
                    if (vm.filteredLocations.length > 0) {
                        return vm.filteredLocations[0].value;
                    }
                    
                    return vm.ordering_location_id;
                };
                
                if (e.is_parent_product && e.children_data && e.children_data.length > 0 && this.autoExpandParents) {
                    console.log('Parent product detected, expanding children:', e.children_data);
                    
                    const existingChildren = this.items.filter(item => 
                        e.children_data.some(child => child.child_sku === item.product_sku)
                    );
                    
                    if (existingChildren.length > 0) {
                        this.$bvToast.toast(
                            "Some child items already exist in the order",
                            {title: "Warning", autoHideDelay: 2000, variant:"warning"}
                        );
                        return;
                    }
                    
                    e.children_data.forEach(child => {
                        const newChildItem = {
                            id: null,
                            product_sku: child.child_sku,
                            product_name: child.child_name,
                            product_id: null,
                            quantity: child.required_quantity,
                            quantity_scheduled: 0,
                            quantity_shipped: 0,
                            quantity_received: 0,
                            wholesale_price: child.child_wholesale_price || 0,
                            cubes: child.child_cubes || 0,
                            locsub: getStockLocation(),
                            reserved_locsub: null,
                            reservedLocationOptions: [],
                            status: 1,
                            delivery_status: 0,
                            original_status: 1,
                            in_stock: child.child_in_stock || 0,
                            reserved: child.child_reserved || 0,
                            available: child.child_available || 0,
                            hasFetchedAvailability: true,
                            shipping_location: '47|123',
                            isOldItem: false,
                            parent_sku: e.product_sku,
                            is_child_product: true,
                            required_quantity: child.required_quantity,
                            image_url: child.child_image_url
                        };

                        vm.items.push(newChildItem);
                        
                        if (newChildItem.quantity > 0) {
                            this.fetchReservedLocations(newChildItem).then(options => {
                                this.$set(newChildItem, 'reservedLocationOptions', options);
                                if (options.length > 0 && !newChildItem.reserved_locsub) {
                                    this.$set(newChildItem, 'reserved_locsub', options[0].value);
                                }
                            });
                        }
                    });
                    
                    this.$bvToast.toast(
                        `Added ${e.children_data.length} child items for parent product ${e.product_sku}`,
                        {title: "Success", autoHideDelay: 2000, variant:"success"}
                    );
                    
                } else if (e.is_parent_product && (!this.autoExpandParents || !e.children_data)) {
                    const newItem = {
                        id: null,
                        product_sku: e.product_sku,
                        product_name: e.product_name,
                        product_id: e.product_id,
                        quantity: 1,
                        quantity_scheduled: 0,
                        quantity_shipped: 0,
                        quantity_received: 0,
                        wholesale_price: e.wholesale_price || 0,
                        cubes: e.cubes || 0,
                        locsub: getStockLocation(),
                        reserved_locsub: null,
                        reservedLocationOptions: [],
                        status: 1,
                        delivery_status: 0,
                        original_status: 1,
                        in_stock: e.total_physical_inventory || 0,
                        reserved: e.total_reserved || 0,
                        available: e.available || 0,
                        hasFetchedAvailability: true,
                        shipping_location: '47|123',
                        isOldItem: false,
                        parent_sku: null,
                        is_child_product: false,
                        is_parent_product: true
                    };

                    vm.items.push(newItem);
                    
                    if (newItem.quantity > 0) {
                        this.fetchReservedLocations(newItem).then(options => {
                            this.$set(newItem, 'reservedLocationOptions', options);
                            if (options.length > 0 && !newItem.reserved_locsub) {
                                this.$set(newItem, 'reserved_locsub', options[0].value);
                            }
                        });
                    }
                    
                } else {
                    const newItem = {
                        id: null,
                        product_sku: e.product_sku,
                        product_name: e.product_name,
                        product_id: e.product_id,
                        quantity: 1,
                        quantity_scheduled: 0,
                        quantity_shipped: 0,
                        quantity_received: 0,
                        wholesale_price: e.wholesale_price || 0,
                        cubes: e.cubes || 0,
                        locsub: getStockLocation(),
                        reserved_locsub: null,
                        reservedLocationOptions: [],
                        status: 1,
                        delivery_status: 0,
                        original_status: 1,
                        in_stock: 0,
                        reserved: 0,
                        available: 0,
                        hasFetchedAvailability: false,
                        shipping_location: '47|123',
                        isOldItem: false,
                        parent_sku: null,
                        is_child_product: false,
                        is_parent_product: false
                    };

                    vm.items.push(newItem);
                    this.fetchItemAvailability(newItem);
                }
                
                this.product_search_keyword = '';
            },
            
            removeParentGroup(parentSku) {
                const childCount = this.items.filter(item => 
                    item.parent_sku === parentSku && item.is_child_product
                ).length;
                
                this.items = this.items.filter(item => 
                    !(item.parent_sku === parentSku && item.is_child_product)
                );
                
                this.$bvToast.toast(
                    `Removed ${childCount} child items for parent ${parentSku}`,
                    {title: "Success", autoHideDelay: 2000, variant:"success"}
                );
            },
            
            getParentName(parentSku) {
                const parentInProducts = this.products.find(p => p.product_sku === parentSku);
                if (parentInProducts) {
                    return parentInProducts.product_name;
                }
                
                const parentInItems = this.items.find(item => 
                    item.product_sku === parentSku && !item.is_child_product
                );
                if (parentInItems) {
                    return parentInItems.product_name;
                }
                
                return parentSku;
            },
            
            loadTransferOrderData: async function() {
                try {
                    this.loading = true;
                    this.loadingItems = true;
                    
                    await new Promise((resolve) => {
                        this.fetch_init().then(() => {
                            console.log("DEBUG - shipping_location_id after fetch_init:", this.selling_location_id);
                            resolve();
                        });
                    });

                    await this.fetch_prereqs();
                    
                    this.dataLoaded = true;
                    
                    if (arguments.length > 0 || this.$bvToast) {
                        this.$bvToast.toast(
                            "Transfer order items and products loaded successfully",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                    }
                } catch (error) {
                    console.error("Error loading transfer order data:", error);
                    this.$bvToast.toast(
                        "Error loading transfer order data",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                } finally {
                    this.loading = false;
                    this.loadingItems = false;
                }
            },
            
            loadPayments: async function() {
                try {
                    this.payments_being_loaded = true;
                    this.paymentsLoading = true;
                    await this.fetch_payments();
                    this.paymentsLoaded = true;
                    
                    this.$bvToast.toast(
                        "Payments data loaded successfully",
                        {title: "Success", autoHideDelay: 1500, variant:"success"}
                    );
                } catch (error) {
                    console.error("Error loading payments:", error);
                    this.$bvToast.toast(
                        "Error loading payments data",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                } finally {
                    this.payments_being_loaded = false;
                    this.paymentsLoading = false;
                }
            },
            
            loadHistory: async function() {
                try {
                    this.historyLoading = true;
                    await this.fetchTransferOrderHistory();
                    this.historyLoaded = true;
                    
                    this.$bvToast.toast(
                        "Order history loaded successfully",
                        {title: "Success", autoHideDelay: 1500, variant:"success"}
                    );
                } catch (error) {
                    console.error("Error loading history:", error);
                    this.$bvToast.toast(
                        "Error loading order history",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                } finally {
                    this.historyLoading = false;
                }
            },
            
            loadAllData: async function() {
                try {
                    this.loading = true;
                    
                    await this.loadTransferOrderData();
                    await this.fetch_order_status();
                    await this.loadPayments();
                    await this.loadHistory();
                    
                    this.$bvToast.toast(
                        "All data loaded successfully",
                        {title: "Success", autoHideDelay: 2000, variant:"success"}
                    );
                } catch (error) {
                    console.error("Error loading all data:", error);
                    this.$bvToast.toast(
                        "Error loading some data. Please try loading individual sections.",
                        {title: "Error", autoHideDelay: 2000, variant:"warning"}
                    );
                } finally {
                    this.loading = false;
                }
            },
            
            refreshData: async function() {
                try {
                    this.loading = true;
                    
                    this.dataLoaded = false;
                    this.paymentsLoaded = false;
                    this.historyLoaded = false;
                    
                    this.items = [];
                    this.products = [];
                    this.payments = [];
                    this.transferOrderHistory = [];
                    this.order_status = null;
                    
                    this.$bvToast.toast(
                        "Refreshing data...",
                        {title: "Info", autoHideDelay: 1000, variant:"info"}
                    );
                    
                    await new Promise(resolve => setTimeout(resolve, 500));
                    
                    this.$forceUpdate();
                    
                } catch (error) {
                    console.error("Error refreshing data:", error);
                } finally {
                    this.loading = false;
                }
            },
            
            exportTransferOrderToExcel: function() {
                if (!this.items || this.items.length === 0) {
                    this.$bvToast.toast(
                        "No items to export",
                        {title: "Warning", autoHideDelay: 1500, variant:"warning"}
                    );
                    return;
                }

                console.log('Exporting items:', this.items.length);

                let ws_data = this.items.map(item => {
                    let deliveryStatusText = '';
                    if (item.delivery_status !== undefined && item.delivery_status !== null) {
                        const statusObj = this.delivery_statuses.find(ds => ds.value === item.delivery_status);
                        deliveryStatusText = statusObj ? statusObj.text : '';
                    }

                    let itemStatusText = '';
                    if (item.status !== undefined && item.status !== null) {
                        itemStatusText = this.status_mapping[item.status] || '';
                    }

                    return {
                        'Transfer Order #': this.id || '',
                        'Product SKU': item.product_sku || '',
                        'Description': item.product_name || '',
                        'Quantity Ordered': item.quantity || 0,
                        'Quantity Scheduled': item.quantity_scheduled || 0,
                        'Quantity Shipped': item.quantity_shipped || 0,
                        'Quantity Received': item.quantity_received || 0,
                        'Item Status': itemStatusText,
                        'Delivery Status': deliveryStatusText,
                        'Cubes': ((item.cubes || 0.0) * (item.quantity || 0.0)).toFixed(2),
                        'Item Location': this.getLocationName(item.reserved_locsub),
                        'Receive Location': this.getLocationName(item.locsub),
                        'Staging Location': this.getLocationName(item.shipping_location),
                        'Drop Location': this.getLocationName(item.locsub),
                        'Wholesale Price': (item.wholesale_price || 0).toFixed(2),
                        'Total Value': ((item.wholesale_price || 0.0) * (item.quantity || 0.0)).toFixed(2),
                        'Schedule Date': item.schedule_date || '',
                        'Requested ETA': item.delivery_date || '',
                        'Received Date': item.received_date || '',
                        'Comments': item.comments || '',
                        'In Stock': item.in_stock || 0,
                        'Reserved': item.reserved || 0,
                        'Available': item.available || 0,
                        'Parent SKU': item.parent_sku || '',
                        'Is Child Product': item.is_child_product ? 'Yes' : 'No'
                    };
                });

                const summaryRow = {
                    'Transfer Order #': 'SUMMARY',
                    'Product SKU': '',
                    'Description': '',
                    'Quantity Ordered': this.items.reduce((sum, item) => sum + (parseInt(item.quantity) || 0), 0),
                    'Quantity Scheduled': this.items.reduce((sum, item) => sum + (parseInt(item.quantity_scheduled) || 0), 0),
                    'Quantity Shipped': this.items.reduce((sum, item) => sum + (parseInt(item.quantity_shipped) || 0), 0),
                    'Quantity Received': this.items.reduce((sum, item) => sum + (parseInt(item.quantity_received) || 0), 0),
                    'Item Status': '',
                    'Delivery Status': '',
                    'Cubes': this.items.reduce((sum, item) => sum + ((item.cubes || 0) * (item.quantity || 0)), 0).toFixed(2),
                    'Item Location': '',
                    'Receive Location': '',
                    'Staging Location': '',
                    'Drop Location': '',
                    'Wholesale Price': '',
                    'Total Value': this.items.reduce((sum, item) => sum + ((item.wholesale_price || 0) * (item.quantity || 0)), 0).toFixed(2),
                    'Schedule Date': '',
                    'Requested ETA': '',
                    'Received Date': '',
                    'Comments': '',
                    'In Stock': '',
                    'Reserved': '',
                    'Available': '',
                    'Parent SKU': '',
                    'Is Child Product': ''
                };

                ws_data.push(summaryRow);

                function escapeCSV(value) {
                    if (value === null || value === undefined) return "";
                    value = value.toString();
                    if (/[",\n]/.test(value)) {
                        value = '"' + value.replace(/"/g, '""') + '"';
                    }
                    return value;
                }

                let headers = Object.keys(ws_data[0]).map(escapeCSV).join(",");
                let rows = ws_data.map(obj => Object.values(obj).map(escapeCSV).join(",")).join("\n");
                let csvContent = headers + "\n" + rows;
                
                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `Transfer_Order_${this.id}_${new Date().toISOString().split('T')[0]}.csv`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                this.$bvToast.toast(
                    `Exported ${this.items.length} items to CSV`,
                    {title: "Success", autoHideDelay: 2000, variant:"success"}
                );
            },
            
            getLocationName: function(locValue) {
                if (!locValue) return 'Unknown Location';
                
                const location = this.filteredLocations.find(loc => loc.value === locValue);
                if (location) return location.text;
                
                if (this.packet.locsubsdict && this.packet.locsubsdict[locValue]) {
                    return this.packet.locsubsdict[locValue];
                }
                
                return locValue;
            },

            validatePaymentAmount() {
                const amount = parseFloat(this.new_payment.amount);

                if (isNaN(amount) || amount <= 0) {
                    this.paymentError = "Please enter a valid payment amount";
                    this.paymentAlertVariant = 'danger';
                    return false;
                }

                const remainingBalance = this.get_total_due() - this.get_total_paid();

                if (amount > remainingBalance) {
                    this.paymentError = `Payment amount cannot exceed remaining balance of $${remainingBalance.toFixed(2)}`;
                    this.paymentAlertVariant = 'danger';
                    return false;
                }

                this.paymentError = null;
                this.paymentAlertVariant = 'secondary';
                return true;
            },
            
            validateShippedQuantity(item) {
                const min = 0;
                const max = item.quantity;
                
                this.$nextTick(() => {
                    let shipped = Number(item.quantity_shipped) || 0;
                    
                    if (shipped < min) {
                        shipped = min;
                    } else if (shipped > max) {
                        shipped = max;
                    }
                    
                    item.quantity_shipped = shipped;
                });
            },
            
            getStatusOptions(item) {
                const scheduledQty = parseInt(item.quantity_scheduled) || 0;
                const orderedQty = parseInt(item.quantity) || 0;
                const receivedQty = parseInt(item.quantity_received) || 0;
                const shippedQty = parseInt(item.quantity_shipped) || 0;
                
                const isScheduleComplete = scheduledQty > 0;
                const isShipped = shippedQty > 0;
                const isReceived = receivedQty > 0;
                
                const options = [
                    { value: 1, text: "ORDERED", disabled: false },
                    { 
                        value: 2, 
                        text: "SCHEDULED", 
                        disabled: scheduledQty > 0
                    },
                    { 
                        value: 6, 
                        text: "SHIPPED", 
                        disabled: !isScheduleComplete
                    },
                    { 
                        value: 3, 
                        text: "RECEIVED", 
                        disabled: !isScheduleComplete
                    },
                    { 
                        value: 4, 
                        text: "PARTIAL", 
                        disabled: !isScheduleComplete || receivedQty <= 0 || receivedQty === scheduledQty 
                    },
                    { value: 5, text: "COMPLETED", disabled: false },
                ];

                return options;
            },
            
            canChangeToReceived(item) {
                const allowedRoles = ['admin', 'officemanager', 'locationadmin'];
                const isAllowedRole = allowedRoles.includes(this.packet.userDetails.userrole);
                
                const scheduledQty = parseInt(item.quantity_scheduled) || 0;
                const isScheduleComplete = scheduledQty > 0;
                
                return isAllowedRole && isScheduleComplete;
            },
            
            disableFutureDates(date) {
                return date > new Date();
            },
            
            onReceivedDateChange(item, date) {
                console.log('Received date changed:', {
                    sku: item.product_sku,
                    newDate: date,
                    currentStatus: item.status
                });

                const today = moment().format('MM-DD-YYYY');
                if (date !== today) {
                    this.$bvToast.toast(
                        "Received date must be today's date",
                        {title: "Validation", autoHideDelay: 2000, variant:"warning"}
                    );
                    this.$set(item, 'received_date', today);
                    return;
                }

                if (date) {
                    const scheduledQty = parseInt(item.quantity_scheduled) || 0;
                    const orderedQty = parseInt(item.quantity) || 0;
                    const receivedQty = parseInt(item.quantity_received) || 0;
                    
                    if (scheduledQty <= 0) {
                        this.$bvToast.toast(
                            "Cannot set received date: Item must be scheduled first",
                            {title: "Validation Error", autoHideDelay: 3000, variant:"warning"}
                        );
                        this.$set(item, 'received_date', null);
                        return;
                    }
                    
                    if (receivedQty <= scheduledQty && receivedQty > 0) {
                        if (receivedQty === scheduledQty) {
                            item.status = 3;
                        } else {
                            item.status = 4;
                        }
                    } else {
                        this.$bvToast.toast(
                            `Cannot set received date: Received quantity (${receivedQty}) must be greater than 0 and less than or equal to scheduled quantity (${scheduledQty})`,
                            {title: "Validation Error", autoHideDelay: 3000, variant:"warning"}
                        );
                        this.$set(item, 'received_date', null);
                    }
                }
            },
            
            applyMainDeliveryDate() {
                if (!this.main_delivery_date) {
                    this.$bvToast.toast(
                        "No main delivery date available",
                        {title: "Warning", autoHideDelay: 1500, variant:"warning"}
                    );
                    return;
                }

                this.delivery_date = this.main_delivery_date;

                let itemsUpdated = 0;

                this.items = this.items.map(item => {
                    if (item.original_status !== 3 && !item.delivery_date) {
                        itemsUpdated++;
                        return {
                            ...item,
                            delivery_date: this.main_delivery_date,
                            has_external_delivery_date: true,
                            status: 2,
                            original_status: item.original_status || item.status
                        };
                    }
                    return item;
                });

                if (itemsUpdated > 0) {
                    this.$bvToast.toast(
                        `Main delivery date (${this.main_delivery_date}) applied to ${itemsUpdated} items. Status set to SCHEDULED.`,
                        {title: "Success", autoHideDelay: 2500, variant:"success"}
                    );
                } else {
                    this.$bvToast.toast(
                        "No items needed the main delivery date applied",
                        {title: "Info", autoHideDelay: 1500, variant:"info"}
                    );
                }

                this.$forceUpdate();
            },
            
            applyMainScheduleDate() {
                if (!this.main_schedule_date) {
                    this.$bvToast.toast(
                        "No main schedule date available",
                        {title: "Warning", autoHideDelay: 1500, variant:"warning"}
                    );
                    return;
                }

                this.schedule_date = this.main_schedule_date;

                let itemsUpdated = 0;

                this.items = this.items.map(item => {
                    if (item.original_status !== 3 && !item.schedule_date) {
                        itemsUpdated++;
                        return {
                            ...item,
                            schedule_date: this.main_schedule_date,
                            has_external_schedule_date: true,
                            status: 2,
                            original_status: item.original_status || item.status
                        };
                    }
                    return item;
                });

                if (itemsUpdated > 0) {
                    this.$bvToast.toast(
                        `Main schedule date (${this.main_schedule_date}) applied to ${itemsUpdated} items. Status set to SCHEDULED.`,
                        {title: "Success", autoHideDelay: 2500, variant:"success"}
                    );
                } else {
                    this.$bvToast.toast(
                        "No items needed the main schedule date applied",
                        {title: "Info", autoHideDelay: 1500, variant:"info"}
                    );
                }

                this.$forceUpdate();
            },
            
            apply_date: function(){
                if (this.delivery_date) {
                    let that = this;
                    this.items = this.items.map(function(d){
                        if (d.original_status !== 3) {
                            d["delivery_date"] = that.delivery_date;
                            d["has_external_delivery_date"] = false;
                        }
                        return d;
                    });
                }
            },
            
            apply_date2: function(){
                if (this.schedule_date) {
                    let that = this;
                    this.items = this.items.map(function(d){
                        if (d.original_status !== 3) {
                            d["schedule_date"] = that.schedule_date;
                            d["has_external_schedule_date"] = false;
                        }
                        return d;
                    });
                }
            },
            
            getShippingLocationOptions(item) {
                const options = [...this.shippingLocationOptions];

                if (item.locsub) {
                    const selectedReserved = (this.filteredLocations || [])
                        .find(loc => loc.value === item.locsub);

                    if (selectedReserved && !options.some(opt => opt.value === selectedReserved.value)) {
                        options.push({
                            value: selectedReserved.value,
                            text: selectedReserved.text
                        });
                    }
                }

                return options;
            },

            fetchItemAvailability: async function(item) {
                if (!item.product_sku) return;
                
                try {
                    this.$set(this.availabilityLoading, item.product_sku, true);
                    
                    const response = await new Promise((resolve, reject) => {
                        Requestor.getSyncP(
                            "/api/product/get_product_list_v4_transfer_order/",
                            {
                                sku: item.product_sku,
                                selling_location: this.selling_location_id
                            },
                            this,
                            resolve,
                            reject
                        );
                    });

                    if (response.data.error) {
                        console.error("Error fetching availability:", response.data.error);
                        return;
                    }

                    const productData = (response.data.result && response.data.result[0]) || {};
                    
                    this.$set(item, 'in_stock', productData.in_stock || 0);
                    this.$set(item, 'reserved', productData.reserved || 0);
                    this.$set(item, 'available', productData.available || 0);
                    this.$set(item, 'hasFetchedAvailability', true);
                    
                    if (item.quantity > 0) {
                        this.$set(this.reservedLocationRequests, item.product_sku, true);
                        
                        const locationOptions = await this.fetchReservedLocations(item);
                        this.$set(item, 'reservedLocationOptions', locationOptions);
                        if (locationOptions.length > 0 && !item.reserved_locsub) {
                            this.$set(item, 'reserved_locsub', locationOptions[0].value);
                        }
                    }
                    
                } catch (error) {
                    console.error("Availability fetch failed:", error);
                } finally {
                    this.$delete(this.availabilityLoading, item.product_sku);
                    this.$delete(this.reservedLocationRequests, item.product_sku);
                }
            },
            
            async fetchReservedLocations(item) {
                try {
                    if (item.id && item.reserved_locsub) {
                        return [{
                            value: item.reserved_locsub,
                            text: this.getLocationName(item.reserved_locsub)
                        }];
                    }
                    
                    const response = await new Promise((resolve, reject) => {
                        Requestor.getSyncP(
                            "/api/product/get_available_inventory_dropdown/",
                            { sku: item.product_sku, selling_location: this.selling_location_id  },
                            this,
                            resolve,
                            reject
                        );
                    });

                    let responseData;
                    if (response && typeof response === 'object') {
                        if ('error' in response || 'result' in response) {
                            responseData = response;
                        }
                        else if (response.data && ('error' in response.data || 'result' in response.data)) {
                            responseData = response.data;
                        }
                    }

                    if (!responseData) {
                        console.error("Invalid API response format:", response);
                        return [];
                    }

                    if (responseData.error) {
                        console.error("API Error:", responseData.error);
                        return [];
                    }

                    return responseData.result || [];

                } catch (error) {
                    console.error("API call failed:", {
                        error: error,
                        message: error.message,
                        response: error.response
                    });
                    return [];
                }
            },

            onQuantityInput(item) {
                const qty = parseInt(item.quantity, 10);
                if (isNaN(qty) || qty <= 0) {
                    this.$set(item, 'quantity', 0);
                    this.$set(item, 'quantity_shipped', 0);
                    
                    if (!item.reserved_locsub) {
                        this.$set(item, 'reservedLocationOptions', []);
                    }
                    this.$set(item, 'reserved_locsub', null);
                    return;
                }

                this.$set(item, 'quantity', qty);
                if (typeof item.quantity_shipped === 'undefined') {
                    this.$set(item, 'quantity_shipped', 0);
                }

                if (item.id && item.reserved_locsub) {
                    console.log('Keeping existing location for old item:', item.product_sku, item.reserved_locsub);
                    
                    if (!item.reservedLocationOptions || item.reservedLocationOptions.length === 0) {
                        this.$set(item, 'reservedLocationOptions', [{
                            value: item.reserved_locsub,
                            text: this.getLocationName(item.reserved_locsub)
                        }]);
                    }
                } else {
                    this.$set(item, 'reservedLocationOptions', []);
                    this.$set(item, 'reserved_locsub', null);
                    
                    this.fetchReservedLocations(item).then(options => {
                        this.$set(item, 'reservedLocationOptions', options);
                        if (options.length > 0) {
                            this.$set(item, 'reserved_locsub', options[0].value);
                        }
                    });
                }
            },

            getImageSrc(image) {
                return image.raw || image.url || '';
            },

            handleImageUpload(event, item, idx) {
                const input = event.target;
                if (input.files && input.files[0]) {
                    const img = { raw: "", url: "", file: null };
                    const reader = new FileReader();

                    reader.onload = (e) => {
                        img.raw = e.target.result;
                        if (!item.images) this.$set(item, 'images', []);
                        item.images = [img];
                        this.$set(this.items, idx, item);
                    };

                    img.file = input.files[0];
                    reader.readAsDataURL(input.files[0]);
                }
            },

            removeImage(item, idx) {
                item.images = [];
                this.$refs['fileInput-' + idx][0].value = '';
                this.$set(this.items, idx, item);
            },

            showImagePreview(item) {
                if (!item.images || item.images.length === 0) return;

                const image = item.images[0];
                this.$bvModal.msgBoxOk('', {
                    title: 'Image Preview',
                    centered: true,
                    size: 'lg',
                    headerBgVariant: 'dark',
                    headerTextVariant: 'light',
                    bodyClass: 'text-center',
                    content: () => (
                        <div>
                            <img
                                src={this.getImageSrc(image)}
                                style="max-width: 100%; max-height: 70vh;"
                                alt="Item Image"
                            />
                        </div>
                    )
                });
            },

            onReservedLocationChange(item) {
                console.log("Reserved location changed for", item.product_sku, "to", item.reserved_locsub);
            },
            
            fetch_order_status: async function() {
                let data = {id: this.id}
                let path = "/api/sales/get_transfer_order_status/"
                let that = this;
                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    } else if (response.data.result && response.data.result.length > 0) {
                        that.order_status = response.data.result[0];
                    }
                }
                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error fetching order status",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                Requestor.getSyncP(path, data, this, s, f);
            },
            
            validateScheduledQuantity(item) {
                const min = this.getMinQuantity(item);
                const max = item.quantity;

                this.$nextTick(() => {
                    if (item.quantity_scheduled < min) {
                        item.quantity_scheduled = min;
                    }
                    if (item.quantity_scheduled > max) {
                        item.quantity_scheduled = max;
                    }

                    if (item.quantity_scheduled > 0 && item.status !== 3) {
                        if (item.status !== 2) {
                            item.status = 2;

                            if (!item.schedule_date) {
                                this.$set(item, 'schedule_date', moment().format('MM-DD-YYYY'));
                            }
                        }
                    } else if (item.quantity_scheduled === 0 && item.status === 2) {
                        item.status = 1;
                    }
                });
            },
            
            onDeliveryDateChange(item, date) {
                console.log('Delivery date changed:', {
                    sku: item.product_sku,
                    newDate: date,
                    currentStatus: item.status
                });

                if (date && item.has_external_delivery_date) {
                    item.has_external_delivery_date = false;
                }

                if (date && item.status !== 3) {
                    this.$nextTick(() => {
                        item.status = 2;
                    });
                }

                if (!date && item.status === 2) {
                    this.$nextTick(() => {
                        item.status = 1;
                    });
                }
            },
            
            onScheduleDateChange(item, date) {
                console.log('Schedule date changed:', {
                    sku: item.product_sku,
                    newDate: date,
                    currentStatus: item.status
                });

                if (date && item.has_external_schedule_date) {
                    item.has_external_schedule_date = false;
                }

                if (date && item.status !== 3) {
                    this.$nextTick(() => {
                        if (item.quantity_scheduled > 0) {
                            item.status = 2;
                        }
                    });
                }

                if (!date && item.status === 2 && (!item.quantity_scheduled || item.quantity_scheduled <= 0)) {
                    this.$nextTick(() => {
                        item.status = 1;
                    });
                }
            },
            
            onScheduledQuantityInput(item) {
                clearTimeout(this.scheduleValidationTimeout);
                this.scheduleValidationTimeout = setTimeout(() => {
                    this.validateScheduledQuantity(item);
                }, 300);
            },
            
            handleStatusChange(item) {
                console.log('Status changed for item:', item.product_sku, 'New status:', item.status);

                const scheduledQty = parseInt(item.quantity_scheduled) || 0;
                const orderedQty = parseInt(item.quantity) || 0;
                const receivedQty = parseInt(item.quantity_received) || 0;
                const shippedQty = parseInt(item.quantity_shipped) || 0;
                
                const originalStatus = item.original_status || item.status;
                
                if (item.status === 6 && scheduledQty <= 0) {
                    this.$bvToast.toast(
                        "Cannot mark as SHIPPED: Item must be scheduled first (scheduled quantity > 0)",
                        {title: "Validation Error", autoHideDelay: 3000, variant:"warning"}
                    );
                    this.$nextTick(() => {
                        item.status = originalStatus;
                    });
                    return;
                }
                
                if (item.status === 3 && scheduledQty <= 0) {
                    this.$bvToast.toast(
                        "Cannot mark as RECEIVED: Item must be scheduled first (scheduled quantity > 0)",
                        {title: "Validation Error", autoHideDelay: 3000, variant:"warning"}
                    );
                    this.$nextTick(() => {
                        item.status = originalStatus;
                    });
                    return;
                }
                
                if (item.status === 4) {
                    if (receivedQty <= 0 || receivedQty >= scheduledQty) {
                        this.$bvToast.toast(
                            "Cannot mark as PARTIAL: Received quantity must be greater than 0 and less than scheduled quantity",
                            {title: "Validation Error", autoHideDelay: 3000, variant:"warning"}
                        );
                        this.$nextTick(() => {
                            item.status = originalStatus;
                        });
                        return;
                    }
                    
                    if (!item.received_date) {
                        this.$set(item, 'received_date', moment().format('MM-DD-YYYY'));
                    }
                }
                
                if (item.status === 2) {
                    if (!item.schedule_date) {
                        this.$set(item, 'schedule_date', moment().format('MM-DD-YYYY'));
                    }

                    if (!item.quantity_scheduled || item.quantity_scheduled <= 0) {
                        this.$set(item, 'quantity_scheduled', item.quantity);
                    }
                }
                
                if (item.status === 3) {
                    this.$set(item, 'received_date', moment().format('MM-DD-YYYY'));
                    
                    if (!item.quantity_received || item.quantity_received === 0) {
                        this.$set(item, 'quantity_received', scheduledQty);
                    }
                }
                
                if (originalStatus === 3 && item.status !== 3 && item.status !== 4) {
                    this.$set(item, 'received_date', null);
                    this.$set(item, 'quantity_received', 0);
                }
            },

            validateQuantity(item) {
                if (item.status === 3) {
                    const scheduledQty = parseInt(item.quantity_scheduled) || 0;
                    const receivedQty = parseInt(item.quantity_received) || 0;
                    
                    if (receivedQty > scheduledQty) {
                        item.quantity_received = scheduledQty;
                    }
                    return;
                }

                const min = this.getMinQuantity(item);
                const scheduledQty = parseInt(item.quantity_scheduled) || 0;
                const max = scheduledQty > 0 ? scheduledQty : item.quantity;

                this.$nextTick(() => {
                    let received = Number(item.quantity_received) || 0;

                    if (received < min) {
                        received = min;
                        this.$bvToast.toast(
                            `Cannot reduce received quantity below ${min} for ${item.product_sku}`,
                            {title: "Warning", autoHideDelay: 2000, variant:"warning"}
                        );
                    } else if (received > max) {
                        received = max;
                    }

                    item.quantity_received = received;

                    if (received <= scheduledQty && scheduledQty > 0) {
                        if (received > 0) {
                            if (received === scheduledQty) {
                                const orderedQty = parseInt(item.quantity) || 0;
                                if (scheduledQty === orderedQty) {
                                    if (this.canChangeToReceived(item)) {
                                        item.status = 3;
                                        if (!item.received_date) {
                                            item.received_date = moment().format('MM-DD-YYYY');
                                        }
                                    } else {
                                        this.$bvToast.toast(
                                            "Insufficient permissions to mark as RECEIVED",
                                            {title: "Permission Error", autoHideDelay: 2000, variant:"warning"}
                                        );
                                        item.quantity_received = min;
                                    }
                                } else {
                                    item.status = 3;
                                }
                            } else {
                                item.status = 4;
                                if (!item.received_date) {
                                    item.received_date = moment().format('MM-DD-YYYY');
                                }
                            }
                        } else {
                            item.status = item.original_status || 1;
                            item.received_date = null;
                        }
                    } else {
                        item.status = item.original_status || 1;
                        item.received_date = null;
                    }
                });
            },
            
            get_total_due: function(){
                let output = 0.0;
                if (this.items){
                    for (var i=0; i<this.items.length; i++){
                        output += this.items[i].wholesale_price * this.items[i].quantity;
                    }
                }
                return output
            },
            
            get_total_paid: function(){
                let output = 0.0;

                if (this.payments){
                    for (var i=0; i<this.payments.length; i++){
                        output += this.payments[i].amount;
                    }
                }
                return output
            },
            
            getMinQuantity(item) {
                return item.original_quantity_received || 0;
            },
            
            isItemDisabled(item) {
                if (item.status === 3) {
                    const isNewlyReceived = item.original_status !== 3;
                    return this.hasRefreshedAfterSave || !isNewlyReceived;
                }
                return false;
            },
            
            getStatusState(item) {
                if (item.status === null || item.status === undefined || item.status === '') {
                    return false;
                } else {
                    if (item.quantity_received > 0) {
                        return [3, 4].includes(item.status) ? null : false;
                    }
                    return null;
                }
            },
            
            preventInvalidEntry(event, item) {
                const allowedKeys = [8, 9, 13, 37, 38, 39, 40, 46];
                if (allowedKeys.includes(event.keyCode)) return;

                const currentValue = event.target.value;
                const newValue = currentValue.slice(0, event.target.selectionStart) +
                                currentValue.slice(event.target.selectionEnd);

                const min = this.getMinQuantity(item);
                const scheduledQty = parseInt(item.quantity_scheduled) || 0;
                const max = scheduledQty > 0 ? scheduledQty : item.quantity;

                if (newValue !== '' && (isNaN(newValue) ||
                    parseInt(newValue) < min ||
                    parseInt(newValue) > max)) {
                    event.preventDefault();
                }
            },

            delete_transfer_order_payment: function(pm){
                let data = {transfer_order_id: this.id, id: pm.id}
                let path = "/api/sales/delete_transfer_order_payment/"
                let that = this;
                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "DELETED PAYMENT ENTRY",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        that.new_payment = {payment_method: null, amount: null}
                        that.fetch_payments();
                    }
                    that.payments_being_loaded = false
                    that.paymentsLoading = false;
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.payments_being_loaded = false
                    that.paymentsLoading = false;
                }
                this.payments_being_loaded = true;
                this.paymentsLoading = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            
            add_transfer_order_payment: function() {
                if (!this.validatePaymentAmount()) {
                    return;
                }

                let data = this.new_payment;
                data.transfer_order_id = this.id;
                let path = "/api/sales/add_transfer_order_payment/"
                let that = this;

                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    } else {
                        that.$bvToast.toast(
                            "ADDED PAYMENT",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        that.new_payment = {payment_method: null, amount: null};
                        that.paymentError = null;
                        that.paymentAlertVariant = 'secondary';
                        that.fetch_payments();
                    }
                    that.payments_being_loaded = false;
                    that.paymentsLoading = false;
                }

                let f = function(error) {
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.payments_being_loaded = false;
                    that.paymentsLoading = false;
                }

                this.payments_being_loaded = true;
                this.paymentsLoading = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            
            validate: function(data){
                let errors = []
                for (var i=0; i<data.items.length; i++){
                    if (!data.items[i].product_sku){
                        errors.push({message: "ONE OR MORE PRODUCTS ARE MISSING THEIR SKUS."});
                    }
                    if (!data.items[i].quantity || data.items[i].quantity <= 0 || isNaN(parseInt(data.items[i].quantity)) ){
                        errors.push({message: "PLEASE SPECIFY A VALID QUANTITY FOR EACH ITEM ORDERED."});
                    }
                }
                return errors;
            },
            
            save_transfer_order_items: function(){
                console.log('=== SAVE TRANSFER ORDER ITEMS ===');
                
                let validationErrors = [];
                
                for (const item of this.items) {
                    if (item.status === 6 && (!item.quantity_scheduled || item.quantity_scheduled <= 0)) {
                        validationErrors.push(`Item ${item.product_sku}: Cannot be SHIPPED without being scheduled first`);
                    }
                    
                    if (item.status === 3 && (!item.quantity_scheduled || item.quantity_scheduled <= 0)) {
                        validationErrors.push(`Item ${item.product_sku}: Cannot be RECEIVED without being scheduled first`);
                    }
                    
                    if (item.status === 3) {
                        const scheduledQty = parseInt(item.quantity_scheduled) || 0;
                        const receivedQty = parseInt(item.quantity_received) || 0;
                        
                        if (scheduledQty <= 0) {
                            validationErrors.push(`Item ${item.product_sku}: Cannot be RECEIVED without scheduled quantity`);
                        }
                    }
                }
                
                if (validationErrors.length > 0) {
                    this.$bvToast.toast(
                        validationErrors.join('. ') + '.',
                        {title: "Validation Errors", autoHideDelay: 5000, variant:"warning"}
                    );
                    return;
                }

                if (this.items.some(item => item.status === null || item.status === undefined || item.status === '')) {
                    return this.$bvToast.toast(
                        "Status missing or invalid",
                        {title: "Missing Fields", autoHideDelay: 2000, variant:"warning"}
                    );
                }

                let data = {
                    id: this.id,
                    username: this.packet.userDetails.username,
                    items: this.items,
                    delivery_date: this.delivery_date,
                    schedule_date: this.schedule_date,
                }

                console.log('Data being sent to server:', JSON.stringify(data, null, 2));

                let that = this;
                let path = "/api/sales/save_transfer_order_items/"
                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "SAVED ITEMS",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        that.loading = false
                        that.hasRefreshedAfterSave = true;
                        
                        for (const item of that.items) {
                            if (item.quantity_received !== undefined && item.quantity_received !== null) {
                                item.original_quantity_received = parseInt(item.quantity_received) || 0;
                            }
                            if (item.status !== undefined && item.status !== null) {
                                item.original_status = item.status;
                            }
                        }
                        
                        that.refreshModalData();
                        
                        setTimeout(() => {
                            that.close_it();
                        }, 1000);
                    }
                    that.loading = false
                    that.saveLoading = false;
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.loading = false
                    that.hasRefreshedAfterSave = false;
                    that.saveLoading = false;
                }
                this.loading = true;
                this.saveLoading = true;
                this.hasRefreshedAfterSave = false;
                Requestor.postSyncP(path, data, this, s, f);
            },
            
            refreshModalData: async function() {
                this.loading = true;
                this.loadingItems = true;
                
                this.items = [];
                
                this.dataLoaded = false;
                this.paymentsLoaded = false;
                this.historyLoaded = false;
                
                this.products = [];
                this.payments = [];
                this.transferOrderHistory = [];
                this.order_status = null;
                
                try {
                    await this.loadAllData();
                    
                    this.$bvToast.toast(
                        "Modal refreshed with latest data",
                        {title: "Success", autoHideDelay: 1500, variant:"success"}
                    );
                } catch (error) {
                    console.error("Error refreshing modal data:", error);
                    this.$bvToast.toast(
                        "Error refreshing data",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                } finally {
                    this.loading = false;
                    this.loadingItems = false;
                }
            },
            
            fetchTransferOrderHistory: function() {
                let data = {id: this.id}
                let path = "/api/sales/get_transfer_order_history/"
                let that = this;
                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            "ERROR RETRIEVING TRANSFER ORDER HISTORY",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.transferOrderHistory = response.data.result;
                    }
                    that.historyLoading = false;
                }

                let f = function(error) {
                    that.$bvToast.toast(
                        "ERROR OCCURRED WITH HISTORY. PLEASE TRY LATER.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.historyLoading = false;
                }
                this.historyLoading = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            
            add_custom_item: function(e){
                let idx = this.items.length;
                let item = {
                    idx: idx+1,
                    product_id: null,
                    product_sku: null,
                    product_name: null,
                    category_id: null,
                    vendor_id: this.vendor_id,
                    cubes: null,
                    quantity: null,
                    quantity_shipped: 0,
                    fob_price: null,
                    selling_price: null,
                    landed_cost: null,
                    wholesale_price: null,
                    cubes: null,
                    product_type: 2,
                    receiving_location_id: null,
                    receiving_sublocation_id: null,
                    quantity_scheduled: null,
                    quantity_received: null,
                    shipping_location: '47|123'
                }

                this.items.push(item);
                return
            },
            
            remove_item: function(item){
                if (! item.id ){
                    this.items = this.items.filter(function(d){return d.product_sku != item.product_sku});
                }
                else {
                    let data = {
                        transfer_order_id: this.id,
                        id: item.id,
                    }
                    let that = this;
                    let path = "/api/sales/delete_transfer_order_item/"
                    let s = function(response) {
                        if (response.data.error){
                            that.$bvToast.toast(
                                response.data.error,
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                        else {
                            that.$bvToast.toast(
                                "DELETED ITEM",
                                {title: "Success", autoHideDelay: 1500, variant:"success"}
                            );

                            that.items = that.items.filter(function(d){return d.product_sku != item.product_sku});
                        }
                        that.loading = false
                        that.saveLoading = false;
                    }

                    let f = function(error) {
                        console.log(error)
                        that.$bvToast.toast(
                            "Error occurred. Please try again.",
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                        that.loading = false
                        that.saveLoading = false;
                    }
                    this.loading = true;
                    this.saveLoading = true;
                    Requestor.getSyncP(path, data, this, s, f);
                }
            },
            
            filter_products: function(item, query){
                return (
                    item.product_name.toLowerCase().indexOf(query.toLowerCase()) > -1
                    ||
                    item.product_sku.toLowerCase().indexOf(query.toLowerCase()) > -1
                )
            },

            fetch_init: function() {
                return new Promise((resolve, reject) => {
                    let data = {id: this.id};
                    let path = "/api/sales/get_transfer_order_items/";
                    let that = this;

                    let s = function(response) {
                        if (response.data.error) {
                            that.$bvToast.toast(
                                "ERROR RETRIEVING TRANSFER ORDER ITEMS",
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                            reject(response.data.error);
                        } else {
                            that.ordering_location_id = response.data.ordering_location;
                            that.selling_location_id = response.data.selling_location;
                            that.main_delivery_date = response.data.main_delivery_date;
                            that.main_schedule_date = response.data.main_schedule_date;

                            console.log("Main delivery date:", that.main_delivery_date);
                            console.log("Main Schedule date:", that.main_schedule_date);
                            console.log("Locations set - ordering:", that.ordering_location_id,
                                    "selling:", that.selling_location_id);

                            that.processItems(response.data.result)
                                .then(() => {
                                    that.loading = false;
                                    that.loadingItems = false;
                                    resolve();
                                })
                                .catch(error => {
                                    that.loading = false;
                                    that.loadingItems = false;
                                    reject(error);
                                });
                        }
                    };

                    let f = function(error) {
                        that.$bvToast.toast(
                            "ERROR OCCURRED. PLEASE TRY AGAIN.",
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                        that.loading = false;
                        that.loadingItems = false;
                        reject(error);
                    };

                    this.loading = true;
                    this.loadingItems = true;
                    Requestor.getSyncP(path, data, this, s, f);
                });
            },

            fetch_prereqs: function() {
                if (this.selling_location_id === null || this.selling_location_id === undefined) {
                    throw new Error("Shipping location is required");
                }

                console.log("Fetching products for location:", this.selling_location_id);

                let data = {
                    selling_location: this.selling_location_id
                };
                let path = "/api/product/get_product_list_for_transfer_order/";
                let that = this;

                this.loadingProducts = true;
                
                return new Promise((resolve, reject) => {
                    Requestor.getAsyncP(path, data, this,
                        function(response) {
                            that.loadingProducts = false;
                            
                            if (response.data.error) {
                                that.$bvToast.toast(
                                    "ERROR RETRIEVING PRODUCT LIST: " + response.data.error,
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                                reject(response.data.error);
                            } else {
                                console.log("Products fetched:", response.data.result.length);
                                that.products = response.data.result;

                                if (that.products.length === 0) {
                                    that.$bvToast.toast(
                                        "No products available for this location",
                                        {title: "Warning", autoHideDelay: 1500, variant:"warning"}
                                    );
                                }

                                that.show = true;
                                resolve();
                            }
                        },
                        function(error) {
                            that.loadingProducts = false;
                            that.$bvToast.toast(
                                "Error retrieving products: " + error.message,
                                {title: "Error", autoHideDelay: 1500, variant:"danger"}
                            );
                            reject(error);
                        }
                    );
                });
            },

            async processItems(items) {
                let vm = this;
                
                for (const item of items) {
                    if (item.status === 3 && !item.received_date) {
                        this.$set(item, 'received_date', moment().format('MM-DD-YYYY'));
                        this.$set(item, 'quantity_received', item.quantity_scheduled || item.quantity);
                        console.log('Fixed missing received_date for:', item.product_sku);
                    }
                    
                    if (!item.locsub || !item.locsub.toString().startsWith(this.ordering_location_id.toString())) {
                        const firstSub = this.packet.locsubs.find(loc =>
                            loc.value.toString().startsWith(this.ordering_location_id + '|')
                        );
                        item.locsub = firstSub ? firstSub.value : this.ordering_location_id;
                    }

                    if (item.status) {
                        item.original_status = item.status;
                    }
                    
                    item.original_quantity_received = parseInt(item.quantity_received) || 0;

                    item.has_external_delivery_date = false;
                    item.has_external_schedule_date = false;

                    if (!item.shipping_location) {
                        item.shipping_location = '47|123';
                    }
                    
                    if (typeof item.quantity_shipped === 'undefined') {
                        item.quantity_shipped = 0;
                    }
                    
                    this.$set(item, 'in_stock', 0);
                    this.$set(item, 'reserved', 0);
                    this.$set(item, 'available', 0);
                    this.$set(item, 'hasFetchedAvailability', false);
                    
                    if (item.reserved_locsub) {
                        this.$set(item, 'reservedLocationOptions', [{
                            value: item.reserved_locsub,
                            text: this.getLocationName(item.reserved_locsub)
                        }]);
                        this.$set(item, 'isOldItem', true);
                    } else {
                        this.$set(item, 'reservedLocationOptions', []);
                        this.$set(item, 'reserved_locsub', null);
                        this.$set(item, 'isOldItem', false);
                    }
                    
                    this.$set(item, 'parent_sku', null);
                    this.$set(item, 'is_child_product', false);
                    this.$set(item, 'required_quantity', 1);
                    this.$set(item, 'is_parent_product', false);
                }

                this.items = items;
            },
            
            fetch_payments: async function(){
                let data = {id: this.id}
                let path = "/api/sales/get_transfer_order_payments/"
                let that = this;
                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            "ERROR RETRIEVING PAYMENTS FOR TRANSFER ORDER",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.payments = response.data.result;
                    }
                    that.payments_being_loaded = false;
                    that.paymentsLoading = false;
                }

                let f = function(error) {
                    that.$bvToast.toast(
                        "ERROR OCCURRED WITH PAYMENTS. PLEASE TRY LATER.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.payments_being_loaded = false;
                    that.paymentsLoading = false;
                }
                this.payments_being_loaded = true;
                this.paymentsLoading = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            
            filter_products_for_vendor: function(){
                let that = this;
                this.vendor_products = this.products.filter(function(d){return d.vendor_id == that.vendor_id});
            },
            
            close_it: function(){
                this.$emit("done-items-co", this.items);
            }
        },
        mounted: function(){
            if (this.$root.transfer_delivery_date && this.$root.transfer_status === 1) {
                console.log('Applying $root delivery date:', this.$root.transfer_delivery_date);

                this.delivery_date = this.$root.transfer_delivery_date;

                setTimeout(() => {
                    if (this.items.length > 0) {
                        this.items = this.items.map(item => {
                            if (item.original_status !== 3) {
                                return {
                                    ...item,
                                    delivery_date: this.$root.transfer_delivery_date
                                };
                            }
                            return item;
                        });
                    }
                }, 100);
            }
            if (this.$root.transfer_schedule_date && this.$root.transfer_status === 1) {
                console.log('Applying $root delivery date:', this.$root.transfer_schedule_date);

                this.schedule_date = this.$root.transfer_schedule_date;

                setTimeout(() => {
                    if (this.items.length > 0) {
                        this.items = this.items.map(item => {
                            if (item.original_status !== 3) {
                                return {
                                    ...item,
                                    schedule_date: this.$root.transfer_schedule_date
                                };
                            }
                            return item;
                        });
                    }
                }, 100);
            }
        },
        computed: {
            anyItemLoading() {
                return Object.keys(this.reservedLocationRequests).length > 0;
            },
            
            groupedItems() {
                const groups = {};
                
                this.items.forEach(item => {
                    let groupKey = 'standalone';
                    
                    if (item.parent_sku && item.is_child_product) {
                        groupKey = item.parent_sku;
                    } else if (item.is_parent_product && !item.is_child_product) {
                        groupKey = item.product_sku;
                    }
                    
                    if (!groups[groupKey]) {
                        groups[groupKey] = [];
                    }
                    
                    groups[groupKey].push(item);
                });
                
                return groups;
            },
            
            computedDeliveryDate: {
                get() {
                    return this.item.delivery_date || this.delivery_date;
                },
                set(value) {
                    this.item.delivery_date = value;
                }
            },
            
            shippingLocationOptions() {
                const meccaLocation = {
                    value: '47',
                    text: 'MECCA SHIPPING'
                };

                const meccaSubLocations = this.packet.locsubs.filter(loc => {
                    const [locationId] = loc.value.toString().split('|');
                    return locationId === '47';
                }).map(loc => ({
                    value: loc.value,
                    text: loc.text || loc.sublocation_name || `MECCA - ${loc.value}`
                }));

                return [meccaLocation, ...meccaSubLocations];
            },
            
            isPaymentAmountValid() {
                if (!this.new_payment.amount) return null;
                const amount = parseFloat(this.new_payment.amount);
                const remainingBalance = this.get_total_due() - this.get_total_paid();
                return amount > 0 && amount <= remainingBalance;
            },
            
            todayDate() {
                return moment().format('MM-DD-YYYY');
            },
            
            allItemsHaveDeliveryDate() {
                return this.items.length > 0 && this.items.every(item => item.delivery_date);
            },
            
            allItemsHaveScheduleDate() {
                return this.items.length > 0 && this.items.every(item => item.schedule_date);
            },
            
            isAdmin() {
                return this.packet.userDetails.userrole === 'admin';
            },
            
            filteredLocations() {
                if (!this.ordering_location_id || !this.packet.locsubs) return [];

                const receivingLoc = this.ordering_location_id.toString();

                return this.packet.locsubs.filter(loc => {
                    const locationText = loc.text || loc.sublocation_name || '';
                    const isDamageLocation = locationText.toLowerCase().includes('damage');
                    
                    return (loc.value.toString().startsWith(receivingLoc + '|') ||
                        loc.value.toString() === receivingLoc) && !isDamageLocation;
                });
            },
            
            shouldDisableFields() {
                if (!this.order_status) return false;

                const restrictedStatuses = [2, 3, 4];
                const isAdmin = this.packet.userDetails.userrole === 'admin';
                return restrictedStatuses.includes(this.order_status.status) && !isAdmin;
            },
            
            statusText() {
                return this.order_status ? this.status_mapping[this.order_status.status] : 'UNKNOWN';
            }
        },
        created: async function() {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.id = this.viewdata.id;

            this.hasRefreshedAfterSave = false;

            if (this.viewdata.delivery_date) {
                this.external_delivery_date = this.viewdata.delivery_date;
                this.delivery_date = this.viewdata.delivery_date;
            }
            if (this.viewdata.schedule_date) {
                this.external_schedule_date = this.viewdata.schedule_date;
                this.schedule_date = this.viewdata.schedule_date;
            }
            if (this.viewdata.status) {
                this.external_status = this.viewdata.status;
            }

            try {
                this.loading = true;
                this.loadingItems = true;
                
                await this.loadTransferOrderData();
                await this.fetch_order_status();
                
                this.dataLoaded = true;
                
                console.log("Transfer order items loaded automatically on modal creation");
            } catch (error) {
                console.error("Error loading transfer order data on creation:", error);
                this.$bvToast.toast(
                    "Error loading transfer order data",
                    {title: "Error", autoHideDelay: 1500, variant:"danger"}
                );
            } finally {
                this.loading = false;
                this.loadingItems = false;
            }
            
            if (this.viewdata.delivery_date && this.order_status && this.order_status.status === 1) {
                this.delivery_date = this.viewdata.delivery_date;
                setTimeout(() => {
                    this.apply_date();
                    this.apply_date2();
                }, 100);
            }
            if (this.viewdata.schedule_date && this.order_status && this.order_status.status === 1) {
                this.schedule_date = this.viewdata.schedule_date;
                setTimeout(() => {
                    this.apply_date();
                    this.apply_date2();
                }, 100);
            }
        },
    }
</script>

<style scoped>
.input-field {
    width: 500px;
}

.loading-disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.eta-badge {
    position: absolute;
    top: -8px;
    right: -8px;
    z-index: 10;
    font-size: 9px;
    padding: 2px 4px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.date-picker-container {
    position: relative;
    display: inline-block;
}

.mx-datepicker {
    position: relative;
}

.apply-delivery-btn {
    margin-left: 15px;
    font-size: 12px;
    padding: 5px 10px;
    margin-top: -60px;
    height:30px;
}

.diver {
    overflow-x: auto;
    overflow-y: visible;
    position: relative;
    max-width: 100%;
    margin: 0;
    padding: 0;
}

/* Table wrapper for better scrolling */
.table-wrapper {
    overflow-x: auto;
    overflow-y: visible;
    position: relative;
    width: 100%;
}

/* Make table wider to enable horizontal scrolling */
.sticky-table {
    min-width: 2350px;
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
}

/* Sticky SKU column (first column) */
.sticky-table > tbody > tr > td:first-child,
.sticky-table > thead > tr > th:first-child,
.sticky-table > thead > tr > td:first-child {
    position: sticky;
    left: 0;
    background-color: white;
    z-index: 20;
    box-shadow: 2px 0 5px -2px rgba(0,0,0,0.1);
}

/* Sticky Description column (second column) */
.sticky-table > tbody > tr > td:nth-child(2),
.sticky-table > thead > tr > th:nth-child(2),
.sticky-table > thead > tr > td:nth-child(2) {
    position: sticky;
    left: 100px;
    background-color: white;
    z-index: 20;
    box-shadow: 2px 0 5px -2px rgba(0,0,0,0.1);
}

/* Header background colors for sticky columns */
.sticky-table > thead > tr > td:first-child,
.sticky-table > thead > tr > td:nth-child(2),
.sticky-table > thead > tr > th:first-child,
.sticky-table > thead > tr > th:nth-child(2) {
    background-color: #efefef;
}

/* Header sticky positioning - FIXED for both header rows */
.sticky-table > thead > tr > th,
.sticky-table > thead > tr > td {
    position: sticky;
    z-index: 15;
    background-color: #efefef;
}

/* First header row */
.sticky-table > thead:first-child > tr > th,
.sticky-table > thead:first-child > tr > td {
    top: 0;
}

/* Second header row (column headers) */
.sticky-table > thead:last-child > tr > th,
.sticky-table > thead:last-child > tr > td {
    top: 32px;
}

/* Second header row sticky columns need higher z-index */
.sticky-table > thead:last-child > tr > th:first-child,
.sticky-table > thead:last-child > tr > td:first-child,
.sticky-table > thead:last-child > tr > th:nth-child(2),
.sticky-table > thead:last-child > tr > td:nth-child(2) {
    z-index: 25;
}

/* Parent group header row should not be sticky */
.sticky-table > tbody > tr > td[colspan] {
    position: static !important;
    left: auto !important;
    background-color: #f0f8ff !important;
}

/* Ensure proper background for sticky columns on hover */
.sticky-table > tbody > tr:hover > td:first-child,
.sticky-table > tbody > tr:hover > td:nth-child(2) {
    background-color: #f8f9fa;
}

/* Fix for availability table inside sticky cells - prevent overlap */
.availability-table {
    width: 100%;
    font-size: 12px;
    border: 1px solid #dee2e6;
    table-layout: fixed;
}

.availability-table th,
.availability-table td {
    padding: 4px 8px;
    border: 1px solid #dee2e6;
}

.availability-table thead th {
    background-color: #f8f9fa;
    font-weight: bold;
}

/* Cell styles */
.srr {
    font-size: 11px;
    text-align: center;
    background: #efefef;
    border: 1px solid #010101;
    font-family: roboto;
}

.srrv {
    font-size: 11px;
    text-align: center;
    background: white;
    border: 1px solid #010101;
    padding: 5px;
    font-family: roboto;
}

.modal-xl {
    min-width: 1000px !important;
}

.mx-input {
    font-size: 12px;
}

.loading-small {
    font-size: 10px;
    padding: 2px 5px;
}

.loading-inline {
    display: inline-flex;
    align-items: center;
    gap: 5px;
}

.reserved-location-loading {
    min-height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8f9fa;
    border: 1px dashed #dee2e6;
    border-radius: 4px;
}

.product-loading-overlay {
    position: relative;
    min-height: 50px;
}

.product-loading-overlay::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
}

.global-loading-indicator {
    animation: slideIn 0.3s ease;
}

.spinner-container {
    display: flex;
    align-items: center;
    justify-content: center;
}

.save-loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
}

.save-loading-content {
    background: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.15);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
}

@keyframes slideIn {
    from {
        transform: translateX(100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

@media screen and (max-width: 768px) {
    .input-field {
        width: 100%;
    }
    
    .diver {
        height: auto;
        overflow-x: auto;
        overflow-y: auto;
    }
}

.export-btn {
    margin-left: 10px;
    background-color: #217346;
    border-color: #217346;
}

.export-btn:hover {
    background-color: #1a5c38;
    border-color: #1a5c38;
}

.ml-0.ml-lg-2 {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
}

.data-loading-section {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 30px;
    text-align: center;
    margin: 20px 0;
    border: 2px dashed #dee2e6;
}

.data-loading-section h5 {
    color: #495057;
    margin-bottom: 10px;
}

.data-loading-section .text-muted {
    color: #6c757d !important;
    margin-bottom: 25px;
}

.data-loading-section .btn {
    transition: all 0.3s ease;
}

.data-loading-section .btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.data-loading-section .btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.refresh-btn {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/TransferOrders/TransferOrderModal.vue